import environment from '../../../config'
import { WindowClarity } from '../../../types/window'

export const loadClarityScript = (): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    const { enabled, apiKey } = environment.clarity

    if (!enabled) return

    window.clarity ??= (...args: unknown[]) => {
      ;(window.clarity as WindowClarity).q ??= []
      ;(window.clarity as WindowClarity).q?.push(args)
    }

    const element = document.createElement('script')

    element.src = 'https://www.clarity.ms/tag/' + apiKey
    element.type = 'text/javascript'
    element.async = true

    element.onload = () => {
      if (environment.debugEnabled) console.log('[CLARITY] Script loaded successfully.')
      resolve()
    }

    element.onerror = (err) => {
      document.head.removeChild(element)
      reject(
        err instanceof Event
          ? `[CLARITY] Could not load script at '${(err.target as HTMLScriptElement).src}'.`
          : err,
      )
    }

    document.head.appendChild(element)
  })
